import CommonLayout from 'components/CommonLayout';
import Body from 'containers/ContactsUtilsPage/Body';
import messages from 'containers/ContactsUtilsPage/messages';
import React from 'react';
import PhoneInTalkOutlinedIcon from '@material-ui/icons/PhoneInTalkOutlined';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';

const ContactsUtilsPage = () => {
  return (
    <GaLoadHOC label="Contacts utils" category={EVENT_CATEGORIES.CONTACTS}>
      <CommonLayout
        icon={<PhoneInTalkOutlinedIcon />}
        title={messages.title}
        content={<Body />}
        fullscreen
      />
    </GaLoadHOC>
  );
};

export default ContactsUtilsPage;
